<div class="how-to-earn">
  <div class="container">
    <div class="header">
      <img loading="lazy" src="../../../../../assets/images/how-to-earn/header.jpg" alt="" />
      <div class="header__card">
        <div class="header__card--title">How You Can Earn on Kachiing</div>
        <div class="header__card--desc">Our platform is designed not only for convenience and community but also for
          providing multiple income-generating opportunities. Whether you're passionate about maintaining a safe digital
          space, helping businesses improve, or sharing your expertise, Kachiing offers diverse ways for you to earn.
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="my-card">
          <div class="my-card__content">
            <div class="my-card__content--title">Referrals</div>
            <div class="my-card__content--desc">One of the best ways to earn from the platform is by referring products
              and services to your friends and family. Each successful purchase made through your referral link earns
              you a commission.</div>
          </div>
          <div class="image">
            <img loading="lazy" src="../../../../../assets/images/how-to-earn/1_LWL-KKFiDehp1kEKUlQl2Q.webp" alt="" />
            <div class="beta">BETA</div>
          </div>
        </div>
        <a class="my-card" routerLink="/news">
          <div class="my-card__content">
            <div class="my-card__content--title">Blog Posts</div>
            <div class="my-card__content--desc">Have knowledge about certain topics that our community can benefit from?
              Why not share it in a blog post! If your article is liked by our community, you can earn!</div>
          </div>
          <div class="image">
            <img loading="lazy" src="../../../../../assets/images/how-to-earn/blog.webp" alt="" />
            <div class="beta">BETA</div>
          </div>
        </a>
        <div class="my-card">
          <div class="my-card__content">
            <div class="my-card__content--title">Reporting</div>
            <div class="my-card__content--desc">Reporting inappropriate or unsavory content on the app can earn you
              points, if your report is approved.</div>
          </div>
          <div class="image">
            <img loading="lazy" src="../../../../../assets/images/how-to-earn/Reporting.webp" alt="" />
            <div class="beta">BETA</div>
          </div>
        </div>
        <div class="my-card">
          <div class="my-card__content">
            <div class="my-card__content--title">Promoting Services</div>
            <div class="my-card__content--desc">For each business listing on Kachiing, you can share feedback about your
              experience with their service via the recommendation section. If your recommendation is liked by many in
              our community, you could be rewarded.</div>
          </div>
          <div class="image">
            <img loading="lazy" src="../../../../../assets/images/how-to-earn/Recommending.png" alt="" />
            <div class="beta">BETA</div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="my-card" (click)="openShopPopup('shop', 0)">
          <div class="my-card__content">
            <div class="my-card__content--title">Selling Products</div>
            <div class="my-card__content--desc">Selling on kachiing is not limited to just businesses. You as a user may
              also set up a store via the store feature in the platform and sell products and services to the people
              around you and your home. To learn more about how to set up your own store. click the link below</div>
          </div>
          <div class="image">
            <img loading="lazy" src="../../../../../assets/images/how-to-earn/Selling.jpeg" alt="" />
            <div class="beta">BETA</div>
          </div>
        </div>

        <a routerLink="/giveaway" class="my-card">
          <div class="my-card__content">
            <div class="my-card__content--title">Giveaways</div>
            <div class="my-card__content--desc">Kachiing hosts numerous giveaways on its platform throughout the month.
              These giveaways are usually sponsored by businesses listing on our app. Participate in them for a chance
              to win attractive rewards and prizes!</div>
          </div>
          <div class="image">
            <img loading="lazy" src="../../../../../assets/images/how-to-earn/Giveaways.png" alt="" />
            <div class="beta">BETA</div>
          </div>
        </a>
        <div class="my-card">
          <div class="my-card__content">
            <div class="my-card__content--title">Suggestions</div>
            <div class="my-card__content--desc">Suggesting improvements for a business can help it grow and scale. If
              your suggestion is liked by platform users and is eventually adopted by the owner, you could earn a some
              rewards. So warm up those hands and start suggesting!</div>
          </div>
          <div class="image">
            <img loading="lazy" src="../../../../../assets/images/how-to-earn/Suggestions.webp" alt="" />
            <div class="beta">BETA</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>